module.exports = __webpack_public_path__ + "static/media/private dick 2 shot.4ce374e1.png";